import { ZodSchema } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import type { FormSchema } from './schema'

export default (schema: ZodSchema<FormSchema>) => {
  return zodResolver(schema)
}
